/**
 * Holds the current RTM connection so code outside the saga (e.g. provisionAccount)
 * can use it to get a promise-based response without going through Redux.
 */
let connectionRef = null;

export function setConnection(conn) {
  connectionRef = conn;
}

export function getConnection() {
  return connectionRef;
}
